import type { LeftnavUpsellProps } from "./components/LeftnavUpsell";
import type * as lazyIndex from "./lazyIndex";
import { createLazyComponent, type LazyComponent, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "BundleName" */ "./lazyIndex"), { name: "BundleName" });

export const LeftnavUpsell: LazyComponent<LeftnavUpsellProps, unknown, void> = createLazyComponent(lazyModule, m => m.LeftnavUpsell);
